"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFQStatus = void 0;
/**
 * @description rfq status
 */
var RFQStatus;
(function (RFQStatus) {
    RFQStatus["IN_PROGRESS"] = "IN_PROGRESS";
    RFQStatus["REQUIRES_APPROVAL"] = "REQUIRES_APPROVAL";
    RFQStatus["AWAITING_SUBMISSIONS"] = "AWAITING_SUBMISSIONS";
    RFQStatus["SELECTED"] = "SELECTED";
    RFQStatus["AWARDED"] = "AWARDED";
    RFQStatus["PUBLISHED"] = "PUBLISHED";
    RFQStatus["ALL"] = "ALL";
})(RFQStatus = exports.RFQStatus || (exports.RFQStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmZxLXN0YXR1cy5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3JmcS90eXBlcy9yZnEtc3RhdHVzLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUg7O0dBRUc7QUFFSCxJQUFZLFNBUVg7QUFSRCxXQUFZLFNBQVM7SUFDbkIsd0NBQTJCLENBQUE7SUFDM0Isb0RBQXVDLENBQUE7SUFDdkMsMERBQTZDLENBQUE7SUFDN0Msa0NBQXFCLENBQUE7SUFDckIsZ0NBQW1CLENBQUE7SUFDbkIsb0NBQXVCLENBQUE7SUFDdkIsd0JBQVcsQ0FBQTtBQUNiLENBQUMsRUFSVyxTQUFTLEdBQVQsaUJBQVMsS0FBVCxpQkFBUyxRQVFwQiJ9